import React, { useCallback, useEffect, useRef, useState } from 'react';
import './find-results.scss';
import { Button, ContextMenu, DataGrid, Popup, Tooltip } from 'devextreme-react';
import { CreateOrders, PdfIcon, UnPdfIcon } from '../../images/icons';
import { RightPanel } from '../../components/utils/right-panel/RighPanel';
import { useAppDispatch, useAppSelector } from '../../contexts/hooks';
import { shallowEqual } from 'react-redux';
import { InfoPanelOrder } from '../../components/utils/info-panels/InfoPanelOrder';
import { InfoPanelPatient } from '../../components/utils/info-panels/InfoPanelPatient';
import { FilterComponent } from './Modals/FilterOrders';
import { useApiSearch } from '../../api/api.Search';
import { Column, FilterRow, HeaderFilter, Item, Paging, Scrolling, Selection, Toolbar } from 'devextreme-react/data-grid';
import moment from 'moment';
import { ConvertDataPatient, ConvertDataOrder, ConvertLocalDate } from '../../utils/functions';
import { Pin, resButtonRefresh, resButtonsMail, resButtonsPrint, UnPin } from '../../images/icons';
import { newToast } from '../../components';
import { SendMailResuls } from '../../components/library/info-order/OrderModules/modals/SendMailResuls';
import { setPanelPined, setPanelVisible } from '../../contexts/slices/orders';
import { ModalReportResults } from '../../components/library/reporting/ModalReportResults';
import { useApiStorage } from '../../api/api.Storage';
import { useApiOrders } from '../../api/api.orders';
import { TypeTableFilter } from '../../types/types.system';

const Index = () => {
  const ColumnsContainerOrderOrders = useAppSelector((x) => x.configuration.Data?.Config_General.filter((x) => x.Cgn_Nombre === 'ColumnsContainerOrderOrders')[0], shallowEqual)?.Cgn_Resultado;
  const ColumnsContainerPatientOrders = useAppSelector((x) => x.configuration.Data?.Config_General.filter((x) => x.Cgn_Nombre === 'ColumnsContainerPatientOrders')[0], shallowEqual)?.Cgn_Resultado;
  const [data, setData] = React.useState<any[]>([]);
  const [modalVisible, setModalVisible] = React.useState(false);
  const { SearchOrder, GetOrderById } = useApiSearch();
  const gridRef = useRef<DataGrid>(null);
  const griResdRef = useRef<DataGrid>(null);
  const [currentDataStudie, setCurrentDataStudie] = React.useState<any>(null);
  const [currentOrder, setCurrentOrder] = React.useState<any>(null);
  const [currentPatient, setCurrentPatient] = React.useState<any>(null);
  const [modalSendMail, setModalSendMail] = useState<{ visible: boolean; studies?: number[] | undefined }>({ visible: false });
  const [modalPrintResult, setModalPrintResult] = useState<{ visible: boolean; studies?: number[] | undefined }>({ visible: false });
  const Prm_ResImprimir = useAppSelector((x) => x.userInfo.Permissions?.Prm_ResImprimir, shallowEqual) ?? false;
  const Prm_Res_Mail = useAppSelector((x) => x.userInfo.Permissions?.Prm_Res_Mail, shallowEqual) ?? false;
  const Prm_Ord = useAppSelector((x) => x.userInfo.Permissions?.Prm_Ord, shallowEqual) ?? false;
  const ModuleEmail: boolean = JSON.parse(useAppSelector((x) => x.configuration.Data?.Config_General.filter((x) => x.Cgn_Nombre === 'ModuleEmail')[0].Cgn_Resultado, shallowEqual) || 'false');
  const panelVisible = useAppSelector((x) => x.globalOrders.PanelVisible, shallowEqual);
  const dispatch = useAppDispatch();
  const { GetFile } = useApiStorage();
  const [showPdfPopup, setShowPdfPopup] = useState(false);
  const [pdfBlobUrl, setPdfBlobUrl] = useState<string | null>(null);
  const { findOrder } = useApiOrders();
  const [loading, setLoading] = useState<boolean>(false);
  const [searchDocument, setSearchDocument] = useState<string>('');

  const handleClickRefresh = () => {
    if (currentOrder) {
      fetchData(currentOrder.Ord_Id);
    }
  };

  const handlePanelClose = () => {
    dispatch(setPanelVisible(true));
    dispatch(setPanelPined(false));
  };

  const handleClickFilter = () => {
    // Logic to filter the data
    setModalVisible(true);
  };

  useEffect(() => {
    const filters = [
      {
        Field: 'Ord_FechaCreacion',
        TypeFilter: 'Between',
        Value: ConvertLocalDate(new Date()),
        Value2: ConvertLocalDate(new Date()),
      },
    ];
    handleApplyFilters(filters);
  }, []);

  const handleClickViewPatient = () => {
    // Logic to view patient details
    console.log('View Patient clicked');
  };

  const handlePdfClick = async (data) => {
    if (data.TieneAdjuntos === 1) {
      setShowPdfPopup(true); // Open the modal immediately
      setPdfBlobUrl(null); // Clear any previous PDF
      console.log('data', data);
      const base64 = await GetFile(data.Oad_Id);
      if (base64) {
        const sanitizedBase64 = base64.file.replace(/\s/g, ''); // Clean up spaces for safety
        const fullDataUrl = `data:application/pdf;base64,${sanitizedBase64}`;
        setPdfBlobUrl(fullDataUrl); // Set the PDF URL once fetched
      } else {
        alert('No se pudo obtener el archivo. Por favor, intente nuevamente.');
      }
    }
  };

  //#region ENVIAR RESULTADOS POR CORREO
  const handleSendMail = useCallback(async () => {
    if (!currentOrder) {
      newToast('INFO', 'No hay orden seleccionada para enviar resultados por correo', 5);
      return;
    }
    const idOrd = currentOrder.Ord_Id;
    if (idOrd === -1) {
      return;
    }
    if (!Prm_Res_Mail) {
      newToast('INFO', 'No cuenta con los permisos para enviar resultados por correo', 5);
      return;
    }
    let info = await griResdRef.current?.instance.getDataSource();
    const data = info?.items();

    if (!data || data.length === 0) {
      newToast('INFO', 'No hay resultados para enviar por correo', 5);
      return;
    }
    //Eliminamos los resultados que no están en estado 2
    const infoFiltered = data.filter((x) => x.PorcentajeValidacion > 0);
    if (infoFiltered.length === 0) {
      newToast('INFO', 'No hay analitos validados para la orden seleccionada', 5);
      return;
    }
    setModalSendMail({ visible: true, studies: undefined });
  }, [setModalSendMail, currentOrder]);

  const handleSendMailSelected = useCallback(async () => {
    if (!currentOrder) {
      newToast('INFO', 'No hay orden seleccionada para enviar resultados por correo', 5);
      return;
    }
    const idOrd = currentOrder.Ord_Id;
    if (idOrd === -1) {
      return;
    }
    if (idOrd === -1) {
      return;
    }
    if (!Prm_Res_Mail) {
      newToast('INFO', 'No cuenta con los permisos para enviar resultados por correo', 5);
      return;
    }

    try {
      let info = await griResdRef.current?.instance.getSelectedRowsData();
      if (!info || info.length === 0) {
        newToast('INFO', 'No hay resultados seleccionados para enviar por correo', 5);
        return;
      }

      info = info.filter((x) => x.PorcentajeValidacion > 0);
      if (info.length === 0) {
        newToast('INFO', 'No hay analitos validados para los estudios seleccionados', 5);
        return;
      }
      //Sacamos los estudios seleccionados
      const selectedStudies: number[] = [];
      const uniqueMap: { [key: number]: boolean } = {};

      info.forEach((obj) => {
        if (!uniqueMap[obj.Res_Es_Id]) {
          uniqueMap[obj.Res_Es_Id] = true;
          selectedStudies.push(obj.Res_Es_Id);
        }
      });
      setModalSendMail({ visible: true, studies: selectedStudies });
    } finally {
      await gridRef.current?.instance.endCustomLoading();
    }
  }, [currentOrder]);

  const handleCloseModalSendMail = useCallback(() => {
    setModalSendMail({ visible: false, studies: undefined });
    griResdRef.current?.instance.clearSelection();
  }, [setModalSendMail]);

  //#endregion

  //#endregion IMPRIMIR
  const handlePrintResults = useCallback(async () => {
    if (!currentOrder) {
      newToast('INFO', 'No hay orden seleccionada para enviar resultados por correo', 5);
      return;
    }
    const idOrd = currentOrder.Ord_Id;
    if (idOrd === -1) {
      return;
    }
    if (!Prm_ResImprimir) {
      newToast('INFO', 'No cuenta con los permisos para imprimir resultados', 5);
      return;
    }
    let info = await griResdRef.current?.instance.getDataSource();
    const data = info?.items();

    if (!data || data.length === 0) {
      newToast('INFO', 'No hay resultados para imprimir', 5);
      return;
    }
    //Eliminamos los resultados que no están en estado 2
    const infoFiltered = data.filter((x) => x.PorcentajeValidacion > 0);
    if (infoFiltered.length === 0) {
      newToast('INFO', 'No hay analitos validados para esta orden', 5);
      return;
    }
    setModalPrintResult({ visible: true });
  }, [currentOrder, setModalPrintResult, griResdRef]);

  const handlePrintResultsSelected = useCallback(async () => {
    if (!currentOrder) {
      newToast('INFO', 'No hay orden seleccionada para enviar resultados por correo', 5);
      return;
    }
    const idOrd = currentOrder.Ord_Id;
    if (idOrd === -1) {
      return;
    }

    if (!Prm_ResImprimir) {
      newToast('INFO', 'No cuenta con los permisos para imprimir resultados', 5);
      return;
    }
    try {
      await gridRef.current?.instance.beginCustomLoading('');
      let info = await griResdRef.current?.instance.getSelectedRowsData(); //Eliminamos los resultados que no están en estado 2
      if (!info || info.length === 0) {
        newToast('INFO', 'No hay resultados seleccionados imprimir', 5);
        return;
      }

      info = info.filter((x) => x.PorcentajeValidacion > 0);
      if (info.length === 0) {
        newToast('INFO', 'No hay analitos validados para los estudios seleccionados', 5);
        return;
      }
      //Sacamos los estudios seleccionados
      const selectedStudies: number[] = [];
      const uniqueMap: { [key: number]: boolean } = {};

      info.forEach((obj) => {
        if (!uniqueMap[obj.Res_Es_Id]) {
          uniqueMap[obj.Res_Es_Id] = true;
          selectedStudies.push(obj.Res_Es_Id);
        }
      });
      setModalPrintResult({ visible: true, studies: selectedStudies });
    } finally {
      await gridRef.current?.instance.endCustomLoading();
    }
  }, [currentOrder]);
  //#endregion

  const handleApplyFilters = (filters) => {
    setModalVisible(false);
    SearchOrder(filters).then((res) => {
      if (res.length > 0) {
        setData(res);
      } else {
        setData([]);
      }
    });
  };

  const handleSearchByDocument = useCallback(
    (document: string) => {
      if (!document || document.trim() === '') {
        newToast('INFO', 'Por favor ingrese un documento para buscar', 3);
        return;
      }
      const filters = [
        {
          Field: 'Pc_Identificacion',
          TypeFilter: TypeTableFilter.Equal,
          Value: document.trim(),
        },
      ];
      SearchOrder(filters).then((res) => {
        if (res.length > 0) {
          setData(res);
          setSearchDocument(''); // Limpiar el campo después de buscar
        } else {
          setData([]);
          newToast('INFO', 'No se encontraron resultados para el documento ingresado', 3);
        }
      });
    },
    [SearchOrder]
  );

  const handleCloseModal = () => {
    setModalVisible(false);
    //Eliminar la selección de la grilla
  };

  const handleFocusedRowChanged = (e) => {
    const selectedRow = e.row.data; // Aquí accedemos a la fila seleccionada

    if (selectedRow) {
      // Si la fila es válida, obtenemos su ID y ejecutamos `findOrder`
      const rowId = selectedRow.Ord_Id;
      fetchData(rowId);
    }
  };

  const fetchData = useCallback(
    async (idOrd) => {
      GetOrderById(idOrd).then((res) => {
        if (res) {
          const { Orden, Paciente, Estudios } = res;
          const convertedData = ConvertDataPatient(Paciente);
          const convertedOrder = ConvertDataOrder(Orden);
          setCurrentPatient(convertedData);
          setCurrentOrder(convertedOrder);
          setCurrentDataStudie(Estudios);

          //setCurrentOrder(res);
        } else {
          setCurrentOrder(null);
        }
      });
    },
    [setCurrentPatient, setCurrentOrder, setCurrentDataStudie]
  );

  const rowPrepared = (e) => {
    if (e.rowType === 'data') {
      const color = e.data.Se_Color;
      if (color && color.trim() !== '') {
        e.rowElement.style.color = color;
      }
      e.rowElement.setAttribute('id', `row-${e.data.Ord_Id}`);
    }
  };

  const handleClosePdfPopup = () => {
    setShowPdfPopup(false);
    setPdfBlobUrl(null);
  };

  const handleClickViewOrder = () => {
    if (currentOrder) {
      findOrder(undefined, currentOrder.Ord_Id, setLoading, true);
    } else {
      newToast('INFO', 'Seleccione una orden', 5);
    }
  };

  return (
    <div className='view crm-contact-list'>
      <div className='view-wrapper-contact-list'>
        <div style={{ width: '100%', height: 'calc(100vh - 100px)' }}>
          <div className='view-wrapper view-wrapper-contact-details'>
            <div className='container-forms-ord'>
              <div className={`colOrd-${ColumnsContainerOrderOrders ? ColumnsContainerOrderOrders : 6}`}>
                <InfoPanelOrder OrdertData={currentOrder} ModuleName='Buscar ordenes' handleClickFilter={handleClickFilter} handleClickRefresh={handleClickRefresh} searchDocument={searchDocument} onSearchDocumentChange={setSearchDocument} onSearchByDocument={handleSearchByDocument} />
              </div>
              <div className={`colOrd-${ColumnsContainerPatientOrders ? ColumnsContainerPatientOrders : 6}`}>
                <InfoPanelPatient PatientData={currentPatient} handleClickViewPatient={handleClickViewPatient} />
              </div>
            </div>
            <div className='detail-values-container'>
              <DataGrid className='grid' dataSource={currentDataStudie} ref={griResdRef} hoverStateEnabled={true} height='calc(100vh - 300px)' repaintChangesOnly={true} highlightChanges={true} rowAlternationEnabled={true} showColumnLines={true}>
                <Selection mode='multiple' />
                <Scrolling mode='virtual' />
                <Toolbar>
                  <Item location='before' visible={currentDataStudie}>
                    <span className='title-text'>{currentDataStudie?.length || 0} Estudios</span>
                  </Item>
                  <Item location='after' locateInMenu='auto' visible={Prm_Ord} showText='inMenu' widget='dxButton'>
                    <Button id='ViewOrder' icon={CreateOrders} text='Ver orden' onClick={handleClickViewOrder} stylingMode='text' />
                    <Tooltip target={'#ViewOrder'} showEvent='mouseenter' hideEvent='mouseleave' position={'top'}>
                      Ver orden
                    </Tooltip>
                  </Item>
                  <Item location='after' locateInMenu='auto' visible={Prm_ResImprimir} showText='inMenu' widget='dxButton'>
                    <Button id='ImprimirResult' icon={resButtonsPrint} text='Imprimir resultados' stylingMode='text' onClick={handlePrintResults} />
                    <ContextMenu width={'auto'} target={'#ImprimirResult'} dataSource={[{ text: 'Imprimir estudios seleccionados', icon: resButtonsPrint }]} onItemClick={handlePrintResultsSelected} />
                    <Tooltip target={'#ImprimirResult'} showEvent='mouseenter' hideEvent='mouseleave' position={'top'}>
                      Imprimir resultados
                    </Tooltip>
                  </Item>
                  <Item location='after' visible={ModuleEmail && Prm_Res_Mail} locateInMenu='auto' showText='inMenu' widget='dxButton'>
                    <Button id='EnviarResultMail' icon={resButtonsMail} text='Enviar resultados por correo' stylingMode='text' onClick={handleSendMail} />
                    <ContextMenu width={'auto'} target={'#EnviarResultMail'} dataSource={[{ text: 'Enviar estudios seleccionados', icon: resButtonsMail }]} onItemClick={handleSendMailSelected} />
                    <Tooltip target={'#EnviarResultMail'} showEvent='mouseenter' hideEvent='mouseleave' position={'top'}>
                      Enviar resultados por correo
                    </Tooltip>
                  </Item>
                  <Item location='after' locateInMenu='auto' showText='inMenu' widget='dxButton'>
                    <Button id='RefrecarResult' icon={resButtonRefresh} text='Refresh' stylingMode='text' onClick={handleClickRefresh} />
                    <Tooltip target={'#RefrecarResult'} showEvent='mouseenter' hideEvent='mouseleave' position={'top'}>
                      Refrescar datos
                    </Tooltip>
                  </Item>
                  <Item location='after' locateInMenu='never' showText='inMenu' widget='dxButton'>
                    <Button id='showpanel' icon={panelVisible ? Pin : UnPin} text={panelVisible ? 'Panel Visible' : 'Panel oculto'} stylingMode='text' onClick={handlePanelClose} />
                    <Tooltip target={'#showpanel'} showEvent='mouseenter' hideEvent='mouseleave' position={'top'}>
                      {panelVisible ? 'Ocultar panel' : 'Abrir panel'}
                    </Tooltip>
                  </Item>
                </Toolbar>
                <Column dataField='Es_Id' caption='Id' visible={false} />
                <Column caption='ESTUDIO' dataField='Es_Nombre' allowFiltering />{' '}
                <Column
                  dataField='PorcentajeValidacion'
                  caption='% VALIDACIÓN'
                  alignment='center'
                  width={150}
                  cellRender={(data) => {
                    const porcentaje = data.value || 0;
                    return (
                      <div className='meter-container'>
                        <meter value={porcentaje} min={0} max={100} low={1} high={99} optimum={100} className='animated-meter' />
                        <span style={{ fontSize: '12px', fontWeight: '600', minWidth: '35px', color: porcentaje === 100 ? '#4caf50' : porcentaje === 0 ? '#f44336' : '#666' }}>{porcentaje}%</span>
                      </div>
                    );
                  }}
                />
                <Column
                  dataField='TieneAdjuntos'
                  caption='PDF'
                  width={80}
                  alignment='center'
                  cellRender={(data) => {
                    const hasAttachments = data.value === 1;
                    return (
                      <div id={`pdfFile${data.row.data.Res_Es_Id}`} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        <img
                          src={hasAttachments ? PdfIcon : UnPdfIcon}
                          alt=''
                          style={{ width: '20px', height: '20px', cursor: hasAttachments ? 'pointer' : 'default' }}
                          onClick={() => {
                            if (hasAttachments) {
                              handlePdfClick(data.row.data);
                            }
                          }}
                        />
                        <Tooltip target={`#pdfFile${data.row.data.Res_Es_Id}`} showEvent='mouseenter' hideEvent='mouseleave' position={'top'}>
                          {hasAttachments ? 'Ver archivo adjunto' : 'Estudio sin adjuntos'}
                        </Tooltip>
                      </div>
                    );
                  }}
                />
              </DataGrid>
            </div>
          </div>
        </div>

        <RightPanel>
          <DataGrid dataSource={data} tabIndex={0} height='100%' onFocusedRowChanged={handleFocusedRowChanged} ref={gridRef} focusedRowEnabled={true} keyExpr='Ord_Id' id='currentOrders' onRowPrepared={rowPrepared} className='gridOrders compact-grid' noDataText='No hay órdenes para mostrar' hoverStateEnabled={true} repaintChangesOnly={true}>
            <Paging enabled={false} />
            <Selection mode='single' />
            <Scrolling mode='virtual' rowRenderingMode='virtual' />
            <FilterRow visible={true} />
            <HeaderFilter visible={true} />
            <Toolbar>
              <Item location='before'>
                <span className='title-text'>{data?.length || 0} Órdenes</span>
              </Item>
              <Item name='searchPanel' location='after' />
            </Toolbar>
            <Column dataField='Ord_Numero' caption='ORDEN' width={100}>
              <HeaderFilter />
            </Column>
            <Column dataField='Pc_Nombre' caption='USUARIO' calculateCellValue={(rowData) => `${rowData.Pc_Nombre || ''} ${rowData.Pc_Apellido1 || ''} ${rowData.Pc_Apellido2 || ''}`} calculateDisplayValue={(rowData) => `${rowData.Pc_Nombre || ''} ${rowData.Pc_Apellido1 || ''} ${rowData.Pc_Apellido2 || ''}`}>
              <HeaderFilter />
            </Column>
          </DataGrid>
        </RightPanel>
      </div>
      {data.map((order) => (
        <Tooltip key={order.Ord_Id} target={`#row-${order.Ord_Id}`} showEvent='mouseenter' hideEvent='mouseleave' position='left'>
          <div className='toolTipFilter'>
            <div>
              <strong>Fecha de creación:</strong> {moment(order.Ord_FechaCreacion).format('DD/MM/YYYY')}
            </div>
            <div>
              <strong>Orden:</strong> {order.Ord_Numero}
            </div>
            <div>
              <strong>Usuario:</strong> {order.Pc_Nombre || ''} {order.Pc_Apellido1 || ''} {order.Pc_Apellido2 || ''}
            </div>
          </div>
        </Tooltip>
      ))}

      <SendMailResuls visible={modalSendMail.visible} setVisible={handleCloseModalSendMail} lstStudies={modalSendMail.studies} patientData={currentPatient} orderData={currentOrder} />
      {modalPrintResult.visible && <ModalReportResults visible={modalPrintResult.visible} setVisible={setModalPrintResult} studies={modalPrintResult.studies} reportName={'Resultados'} idOrd={currentOrder.Ord_Id} />}
      <FilterComponent onApplyFilters={handleApplyFilters} visible={modalVisible} setVisible={handleCloseModal} includeOrderFields={true} includePatientFields={true} />

      <Popup visible={showPdfPopup} onHiding={handleClosePdfPopup} onHidden={handleClosePdfPopup} showCloseButton showTitle={true} title='Vista previa del archivo' fullScreen dragEnabled>
        {pdfBlobUrl ? (
          <object data={pdfBlobUrl} type='application/pdf' width='100%' height='100%'>
            <p>
              Tu navegador no soporta la visualización de PDF.{' '}
              <a href={pdfBlobUrl} target='_blank' rel='noopener noreferrer'>
                Haz clic aquí para descargarlo
              </a>
              .
            </p>
          </object>
        ) : (
          <div style={{ textAlign: 'center', marginTop: '20px' }}>Cargando documento...</div>
        )}
      </Popup>
    </div>
  );
};

export default Index;
